import React, { useEffect, useState } from 'react';
import { XMLParser } from 'fast-xml-parser';

const InstagramFeed = ({ limit = 6 }) => {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchFeed = async () => {
            try {
                const res = await fetch('/api/instagram');
                const xml = await res.text();

                const parser = new XMLParser({
                    ignoreAttributes: false,
                    attributeNamePrefix: '@_'
                });
                const json = parser.parse(xml);

                // RSS items
                let items = json?.rss?.channel?.item ?? [];

                // If only one item, make it an array
                if (!Array.isArray(items)) items = [items];

                // Map to simple post objects
                const mapped = items.slice(0, limit).map(item => ({
                    title: item.title,
                    link: item.link,
                    date: item.pubDate,
                    description: item.description
                }));

                setPosts(mapped);
            } catch (err) {
                console.error('Instagram feed error:', err);
            } finally {
                setLoading(false);
            }
        };

        fetchFeed();
    }, [limit]);

    if (loading) {
        return <div className="text-center py-6">Loading Instagram feed...</div>;
    }

    if (!posts.length) {
        return <div className="text-center py-6">No posts yet.</div>;
    }

    return (
        <div className="space-y-4">
            <h2 className="text-2xl font-bold">Latest from @muqalabhoops</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                {posts.map((post, idx) => (
                    <a
                        key={idx}
                        href={post.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="bg-white rounded-lg shadow-md p-4 hover:shadow-lg transition"
                    >
                        <div
                            className="text-gray-700 text-sm mb-2"
                            dangerouslySetInnerHTML={{ __html: post.description }}
                        />
                        <h3 className="font-semibold text-gray-800 truncate">{post.title}</h3>
                        <p className="text-gray-500 text-xs mt-1">
                            {new Date(post.date).toLocaleDateString('en-US', {
                                year: 'numeric',
                                month: 'short',
                                day: 'numeric'
                            })}
                        </p>
                    </a>
                ))}
            </div>
        </div>
    );
};

export default InstagramFeed;
